import styled from 'styled-components';
export const MainMenuContainer = styled.div.withConfig({
  displayName: "MainMenustyle__MainMenuContainer",
  componentId: "sc-1thqwu1-0"
})(["", " .active{", " &::after{content:'';", "}}"], {
  "display": "flex",
  "justifyContent": "space-between",
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(88 88 88 / var(--tw-text-opacity, 1))",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms"
}, {
  "position": "relative",
  "--tw-text-opacity": "1",
  "color": "rgb(23 23 23 / var(--tw-text-opacity, 1))",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms"
}, {
  "position": "absolute",
  "bottom": "0px",
  "left": "0px",
  "right": "0px",
  "height": "0.25rem",
  "width": "100%",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(223 43 65 / var(--tw-bg-opacity, 1))",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms"
});
export const MainMenuList = styled.div.withConfig({
  displayName: "MainMenustyle__MainMenuList",
  componentId: "sc-1thqwu1-1"
})(["", " &:hover{", " a{", "}svg{stroke:", ";}}svg{fill:transparent;stroke:", ";}"], {
  "display": "flex",
  "cursor": "pointer",
  "alignItems": "center",
  "gap": "0.5rem",
  "whiteSpace": "nowrap",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "paddingTop": "1.25rem",
  "paddingBottom": "1.25rem",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(223 43 65 / var(--tw-text-opacity, 1))",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(223 43 65 / var(--tw-text-opacity, 1))",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms"
}, ({
  theme
}) => theme.colors.primary[40], ({
  theme
}) => theme.colors.grey[30]);